import React, { RefObject, useEffect, useRef } from "react";
import { FieldsProps } from "../filter.popup";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {Form, Input} from "antd";

export const JsonbFields: React.FC<FieldsProps> = ({ popupRef, config }) => {
    const t = useTranslate();
    const inputRef = useRef() as RefObject<any>;

    useEffect(() => {
        inputRef.current.focus();
    }, [inputRef.current]);

    return (
        <Form.Item>
            <Input.Group compact>
                <Form.Item
                    noStyle
                    name={["fields", config.name, "values", 0]}
                    rules={[
                        {
                            required: true,
                            message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                        },
                    ]}
                >
                    <Input
                        ref={inputRef}
                        placeholder={"Key"}
                        style={{width: "25%"}}
                    />
                </Form.Item>
                <Form.Item
                    noStyle
                    name={["fields", config.name, "values", 1]}
                    rules={[
                        {
                            required: true,
                            message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                        },
                    ]}
                >
                    <Input
                        placeholder={"Value"}
                        style={{width: "75%"}}
                    />
                </Form.Item>
            </Input.Group>
        </Form.Item>
    );
};
